import { dateRequiredSchema, endnDateSchema, select2RequiredSchema, statusSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, number } from 'yup';
import errorMessages from 'utils/validation/errorMessages';

const addProgramSchema = object().shape({
    name: stringRequiredSchema,
    start_date: dateRequiredSchema,
    end_date: endnDateSchema,
    // day: select2RequiredSchema,
    days: array()
        .min(1, "This field is required")
        .required("This field is required"),

    time: stringRequiredSchema,
    location: stringRequiredSchema,
    therapist_head1: select2RequiredSchema,
    therapist_head2: select2RequiredSchema,
    funding_source: select2RequiredSchema,
    location_type: select2RequiredSchema,
    status: statusSchema,
    // lessons: array().of(object().shape({
    //     label: stringRequiredSchema,
    //     value: stringRequiredSchema,
    // })).min(1, errorMessages.required),
});

export default addProgramSchema;